import React from 'react'

const ThemeButtons = ({ setThemeColor }) => {
    return (
        <div className='flex justify-center gap-3'>
            <ThemeCircle setThemeColor={setThemeColor} value="" bg="bg-red-500" />
            <ThemeCircle setThemeColor={setThemeColor} value="yellow" bg="bg-yellow-500" />
            <ThemeCircle setThemeColor={setThemeColor} value="emerald" bg="bg-emerald-500" />
            <ThemeCircle setThemeColor={setThemeColor} value="orange" bg="bg-orange-500" />
            <ThemeCircle setThemeColor={setThemeColor} value="purple" bg="bg-purple-500" />
            <ThemeCircle setThemeColor={setThemeColor} value="rose" bg="bg-rose-500" />
            <ThemeCircle setThemeColor={setThemeColor} value="cyan" bg="bg-cyan-500" />
        </div>
    )
}

const ThemeCircle = (props) => {
    return (
        <button onClick={() => props.setThemeColor(props.value)} className={'w-[30px] h-[30px] rounded-full border-4 border-white/50 ' + props.bg}></button>
    )
}

const ThemeStyleSwitcher = ({ themeColor, setThemeColor }) => {

    return (
        <div >
            <ThemeButtons setThemeColor={setThemeColor} />
        </div>
    )
}

export default ThemeStyleSwitcher